export * from './lib'

/** Lazy — keeps SettingsSidebar (and its graph) off SettingsNames imports. */
export const loadSettingsSidebar = () => (
  import('./ui/settings-sidebar.vue').then((m) => m.default)
)
